import { AxiosResponse, AxiosError } from 'axios';

// Constants
import {
    SPRAY_EVENTS_FOR_SUBMISSION_LOAD_REQUESTED,
    SPRAY_EVENTS_FOR_SUBMISSION_LOAD_SUCCEEDED,
    SPRAY_EVENTS_FOR_SUBMISSION_LOAD_FAILED,
    RESET_SPRAY_EVENTS_FOR_SUBMISSION
} from './constants';

// Types
import {
    RequestLoadSprayEventsForSubmissionAction,
    SucceededLoadSprayEventsForSubmissionAction,
    FailedLoadSprayEventsForSubmissionAction,
    ResetSprayEventsForSubmissionAction
} from './types';

export function requestLoadSprayEventsForSubmission(): RequestLoadSprayEventsForSubmissionAction {
    return {
        type: SPRAY_EVENTS_FOR_SUBMISSION_LOAD_REQUESTED
    };
}

export function succeededLoadSprayEventsForSubmission(
    response: AxiosResponse
): SucceededLoadSprayEventsForSubmissionAction {
    return {
        type: SPRAY_EVENTS_FOR_SUBMISSION_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadSprayEventsForSubmission(
    error: AxiosError
): FailedLoadSprayEventsForSubmissionAction {
    return {
        type: SPRAY_EVENTS_FOR_SUBMISSION_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function resetSprayEventsForSubmission(): ResetSprayEventsForSubmissionAction {
  return {
      type: RESET_SPRAY_EVENTS_FOR_SUBMISSION
  };
}
